<template>
  <div>
    <v-alert
      :type="cargaSelec.carga_programada ? 'success' : 'warning'"
      prominent
      border="left"
      text
      dense
      class="mb-0"
      rounded="lg"           
    >
      <v-row dense>
        <v-col
          xl="8"
          lg="8"
          md="8"
          cols="12"
          align-self="center"
          :class="{ 'text-center': isMobile() }"
        >
          <span :class="{ 'body-2': isMobile(), 'body-1': !isMobile() }">{{
            cargaSelec.carga_programada
              ? "Carga já enviada para programação de carregamento"
              : "Carga ainda não foi enviada para a programação de carregamento"
          }}</span>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12" align-self="center">
          <v-dialog v-model="dialog" max-width="400" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="float-right"
                :depressed="isMobile()"
                block
                rounded
                :color="cargaSelec.carga_programada ? 'error' : 'teal'"
                text
                v-on="on"
                v-bind="attrs"
              >
                <v-icon class="mr-2">
                  {{
                    cargaSelec.carga_programada
                      ? "mdi-truck-remove-outline"
                      : "mdi-truck-delivery-outline"
                  }}</v-icon
                >

                {{
                  cargaSelec.carga_programada
                    ? "Cancelar programação"
                    : "Programar carga"
                }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="font-weight-bold">{{
                cargaSelec.carga_programada
                  ? "Remover da programação de carregamento??"
                  : "Enviar para programação de carregamento??"
              }}</v-card-title>
              <v-card-text>
                <ul>
                  <li>
                    ID carga: <b>{{ cargaSelec.id }}</b>
                  </li>
                  <li>
                    Descrição: <b>{{ cargaSelec.descricao }}</b>
                  </li>
                  <li>
                    Placa: <b>{{ cargaSelec.placa }}</b>
                  </li>
                </ul>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :loading="confirmando"
                  color="success"
                  text
                  rounded
                  class="font-weight-bold"
                  @click="confirmarProgramacaoCarga()"
                  >Confirmar</v-btn
                >
                <v-btn
                  :loading="confirmando"
                  text
                  @click="dialog = false"
                  rounded
                  >Cancelar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-alert>
  </div>

  <!-- <v-dialog v-model="dialog" max-width="400" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        :color="cargaSelec.carga_programada ? 'error' : '#4DB6AC'"
        block
        text
        rounded
        class="font-weight-bold"
      >
        <template v-if="cargaSelec.carga_programada">
          <v-icon left>mdi-truck-remove-outline</v-icon> Remover da programação
          de carregamento
        </template>
        <template v-else>
          <v-icon left>mdi-truck-delivery-outline</v-icon> Enviar para a
          programação de carregamento
        </template>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">{{
        cargaSelec.carga_programada
          ? "Remover da programação de carregamento??"
          : "Enviar para programação de carregamento??"
      }}</v-card-title>
      <v-card-text>
        <ul>
          <li>
            ID carga: <b>{{ cargaSelec.id }}</b>
          </li>
          <li>
            Descrição: <b>{{ cargaSelec.descricao }}</b>
          </li>
          <li>
            Placa: <b>{{ cargaSelec.placa }}</b>
          </li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="confirmando"
          color="success"
          text
          rounded
          class="font-weight-bold"
          @click="confirmarProgramacaoCarga()"
          >Confirmar</v-btn
        >
        <v-btn :loading="confirmando" text @click="dialog = false" rounded
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog> -->
</template>

<script>
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: mapState("formacaoCarga", ["cargaSelec", "cargas"]),
  data: () => ({
    dialog: false,
    confirmando: false,
  }),
  methods: {
    ...mapActions("formacaoCarga", ["buscarCargas"]),
    ...mapMutations("formacaoCarga", ["setIdCarga", "setSelecionarCarga"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async confirmarProgramacaoCarga() {
      this.confirmando = true;

      var options = {
        method: this.cargaSelec.carga_programada ? "delete" : "post",
        data: { id: this.cargaSelec.id },
        url: "nutricao-animal/formacao-carga/programacao-carga",
      };

      await axios
        .request(options)
        .then(async (res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);

            this.setSelecionarCarga(true);
            this.setIdCarga(this.cargaSelec.id);
            await this.buscarCargas();
            this.setSelecionarCarga(false);

            this.dialog = false;
          } else {
            this.$toasted.error(res.data.msg);
          }
        })
        .catch((e) => this.$toasted.error(e));

      this.confirmando = false;
    },
  },
};
</script>

<style>
</style>